module.exports = __webpack_public_path__ + "img/icon-criminal-damage.1ec25215.svg";